import { render } from "./DashboardComponent.vue?vue&type=template&id=0138721e"
import script from "./DashboardComponent.vue?vue&type=script&lang=js"
export * from "./DashboardComponent.vue?vue&type=script&lang=js"

import "./DashboardComponent.vue?vue&type=style&index=0&id=0138721e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__